export default "__VITE_ASSET__Cgc$tNv___"